import { render, staticRenderFns } from "./RTypePlaceEmptyState.vue?vue&type=template&id=3c1ce171&"
import script from "./RTypePlaceEmptyState.vue?vue&type=script&lang=js&"
export * from "./RTypePlaceEmptyState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./RTypePlaceEmptyState.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c1ce171')) {
      api.createRecord('3c1ce171', component.options)
    } else {
      api.reload('3c1ce171', component.options)
    }
    module.hot.accept("./RTypePlaceEmptyState.vue?vue&type=template&id=3c1ce171&", function () {
      api.rerender('3c1ce171', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/RTypePlaces/RTypePlaceEmptyState.vue"
export default component.exports